import Product from '../../../models/Product'

import { getProductRequestObj, buildFilterUrl } from '../../selectors/products'
import { setFilterUrl } from './filters'

export const START_LOAD_PRODUCTS = 'START_LOAD_PRODUCTS'
export const FETCH_PRODUCTS_SUCCESS = 'FETCH_PRODUCTS_SUCCESS'
export const FETCH_PRODUCTS_FAIL = 'FETCH_PRODUCTS_FAIL'

export function productRequestError (hasErrored) {
  return {
    type: FETCH_PRODUCTS_FAIL,
    hasErrored: hasErrored
  }
}

export function startLoadProducts (reloadAll) {
  return {
    type: START_LOAD_PRODUCTS,
    reloadAll
  }
}

export function productsFetchedSuccess (products, total, reloadAll) {
  return {
    type: FETCH_PRODUCTS_SUCCESS,
    products,
    total,
    reloadAll
  }
}

export function loadProductsPage (reloadAll = true, callback = () => {}) {
  return (dispatch, getState) => {
    dispatch(startLoadProducts(reloadAll))

    const store = getState()
    // const filterParams = getProductRequestObj(store.ui.products.filters)
    const filterParams = { ...getProductRequestObj(store.ui.products.filters), ...store.ui.products.defaultFilter }
    const newUrl = buildFilterUrl(store.ui.products.filters)

    Product.findAll(filterParams)
      .then(response => {
        return response
      })
      .then(response => {
        dispatch(
          productsFetchedSuccess(
            response.data,
            response.headers.total,
            reloadAll
          )
        )
        dispatch(setFilterUrl(newUrl))
        callback()

        // Google Tag Manager
        if (window.dataLayer) {
          let planIds = []

          for (let i = 0; i < response.data.length; i++) {
            const product = response.data[i]
            if (product.actableType === 'Plan') {
              planIds.push('plan_' + product.id)
            }
            if (planIds.length >= 5) break
          }

          window.dataLayer.push({
            'event': 'plansLoaded',
            'planIds': planIds
          })
        }
      })
  }
}
